import React from 'react';
import { StyleSheet, Switch, Text, View, type StyleProp, ViewStyle } from 'react-native';
import { ticketColors, ticketFonts } from '../theme/ticketColors';
import {
  NOTIFY_CUSTOMER_READY_PICKUP_LABEL,
  notifyCustomerReadyPickupDescription,
} from './notifyCustomerReadyPickupCopy';

type NotifyCustomerReadyPickupSwitchRowProps = {
  value: boolean;
  onValueChange: (value: boolean) => void;
  disabled?: boolean;
  hasKitchenTickets?: boolean;
  style?: StyleProp<ViewStyle>;
  testID?: string;
  trackColorOn?: string;
};

export function NotifyCustomerReadyPickupSwitchRow({
  value,
  onValueChange,
  disabled = false,
  hasKitchenTickets = false,
  style,
  testID = 'storefront.notify-ready-pickup',
  trackColorOn = ticketColors.gold,
}: NotifyCustomerReadyPickupSwitchRowProps) {
  return (
    <View style={[styles.row, style]}>
      <View style={styles.copy}>
        <Text style={styles.label}>{NOTIFY_CUSTOMER_READY_PICKUP_LABEL}</Text>
        <Text style={styles.desc}>{notifyCustomerReadyPickupDescription(hasKitchenTickets)}</Text>
      </View>
      <Switch
        value={value}
        onValueChange={onValueChange}
        disabled={disabled}
        trackColor={{ false: ticketColors.rule, true: trackColorOn }}
        thumbColor={ticketColors.ink}
        accessibilityLabel={NOTIFY_CUSTOMER_READY_PICKUP_LABEL}
        testID={testID}
      />
    </View>
  );
}

const styles = StyleSheet.create({
  row: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 12,
  },
  copy: {
    flex: 1,
    paddingRight: 8,
  },
  label: {
    fontSize: 14,
    fontWeight: '600',
    color: ticketColors.ink,
    fontFamily: ticketFonts.sans,
  },
  desc: {
    marginTop: 4,
    fontSize: 13,
    lineHeight: 18,
    color: ticketColors.ink2,
    fontFamily: ticketFonts.sans,
  },
});
